import { Button, Flex, Form, Modal } from "antd";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { CustomTitle } from "../../../../../common/customTitle";
import { t } from "i18next";
import TextArea from "antd/es/input/TextArea";
import { sanitizeDataTypeClientSide } from "../../../../../../utils/utils";
import RequiredLabel from "../../../../../common/required-label/RequiredLabel";
import { updateCustomerStatusAction } from "../../../../../../redux/services/customers/customersServices";

const AcceptRejectStatusDialog = ({ open, onClose, status }) => {
  /* For navigating between pages */
  const navigate = useNavigate();
  /* For navigating between pages */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  /* loading dependencies */

  /* form dependencies */
  const [form] = Form.useForm();
  /* form dependencies */

  /* id dependencies */
  const { selectedCustomerId } = useSelector((state) => state.customers);
  /* id dependencies */

  /* initial dependencies */
  useEffect(() => {
    if (
      !selectedCustomerId ||
      selectedCustomerId === "" ||
      selectedCustomerId === null ||
      selectedCustomerId === undefined
    ) {
      onClose();
    }
  }, [selectedCustomerId]);
  /* initial dependencies */

  /* dialog close dependencies */
  const handleDialogClose = () => {
    onClose();
    form.resetFields();
  }
  /* dialog close dependencies */

  /* on submit action */
  const onSubmit = (values) => {
    const dataToBeSent = {
      ...values,
      status: status === "isAccepted" ? "active" : "inactive",
      is_accepted: status === "isAccepted" ? true : false,
      selectedCustomerId
    }
    dispatch(updateCustomerStatusAction(dataToBeSent, setLoading)).then(()=>{
      handleDialogClose()
    })
  };
  /* on submit action */

  return (
    <Modal
      open={open}
      onCancel={handleDialogClose}
      footer={false}
      confirmLoading={loading}
    >
      <Flex vertical gap="2rem">
        <CustomTitle textDecoration="underline" justifyContent="center">
          {status === "isAccepted" ? t("CommonUtils.accept") : t("CommonUtils.reject")}
        </CustomTitle>
        <Form
          form={form}
          layout="vertical"
          autoComplete="off"
          requiredMark={false}
          onFinish={onSubmit}
        >
          <Form.Item
            label={
              <RequiredLabel
                text={t("Modules.ServiceProviderAuth.remarks")}
                required={true}
              />
            }
            name="verification_remark"
            normalize={(value) => sanitizeDataTypeClientSide(value)}
            rules={[
              {
                required: true,
                message: t(
                  "Modules.ServiceProviderAuth.pleaseEnterRemarks"
                ),
              },
              {
                whitespace: true,
                message: t(
                  "Modules.ServiceProviderAuth.pleaseEnterRemarks"
                ),
              },
            ]}
          >
            <TextArea rows={4} />
          </Form.Item>
          <Flex justify="center" align="center">
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            disabled={loading}
          >
            {t("CommonUtils.submit")}
          </Button>
          </Flex>
        </Form>
      </Flex>
    </Modal>
  );
};

export default AcceptRejectStatusDialog;
